<div
  *ngIf="!is_read_running"
  class="sp-width__full sp-min-height__full sp-column">
  <app-store-details-order-data-table
    *ngIf="orders?.length"
    [orders]="orders || []"
    class="sp-width__full"></app-store-details-order-data-table>

  <!--<div
    *ngIf="cursor"
    #seller_load_more
    class="sp-width__full sp-row__center">
    <app-shared-button
      [button_class]="'sp-button__plain sp-width__fit-content sp-margin__top-x2'"
      [spinner_class]="'sp-spinner__secondary'"
      [cta]="'GENERAL.LOAD_MORE_CTA'"
      [is_disabled]="is_load_more_running"
      [is_spinner_visible]="is_load_more_running"
      (button_click)="onLoadMoreClick()"></app-shared-button>
  </div>-->
</div>

<app-loading *ngIf="is_read_running"></app-loading>
